
import { IGlobalState } from "@/store";
import { computed, defineComponent, onMounted, reactive, toRefs } from "vue";
import { useStore } from "vuex";
import { useApplicationList } from "@/hooks/frontApp";
import { IApplication } from "@/typings/application";
import { useRouter } from "vue-router";
import { deleteAppInfo } from "@/service/api";
import { ElMessage } from "element-plus";

export default defineComponent({
  props: {
    keyWord: {
      type: String,
      default: "",
    },
    shelfState: {
      type: Number,
      default: 1,
    },
    userId: {
      type: String,
      default: "",
    },
  },
  setup(props, context) {
    const store = useStore<IGlobalState>();
    const router = useRouter();

    const state = reactive({
      delDialogVisible:false,
      delAppApiId:'',
      clickModalClose:false,
      reflush:true
    });

    const applications = computed(() => store.state.frontApp.applications);

    // 获取当前页码数
    const page = computed({
      get: () => store.state.frontApp.applications.page,
      set: (val) => {
        store.state.frontApp.applications.page = val;
      },
    });
    /**
     * 获取应用列表
     */
    const getApplications = async () => {
      await useApplicationList(
        store,
        props.userId,
        props.keyWord,
        props.shelfState === 3 ? 0:props.shelfState,
        page.value,
        applications.value.limit
      );
    };
    /**
     * 搜索
     */
    async function handleSearch() {
      page.value = 1;
      await getApplications();
    }
    /**
     * 点击管理应用 跳转至应用管理页
     */
    function manageApp(row: IApplication) {
      router.push({ path: "/manageappindex", query: { appid: row.id } });
    }
    /**
     * 修改应用
     */
    function editApp(row: IApplication) {
      router.push({ path: "/addapp", query: { appid: row.id } });
      // router.push("/addapp");
    }
    /**
     * 点击删除应用按钮
     */
    function wantDelApp(index: number){
      state.delAppApiId = applications.value.rows[index].id;
      state.delDialogVisible = true;
    }
    /**
     * 删除应用
     */
    async function delApp(){
      const params = {
        id: state.delAppApiId,
      };
      const result = await deleteAppInfo(params);
      if (result.code == 1) {
        ElMessage({ message: "删除成功", type: "success" });
        state.delDialogVisible = false;
        await getApplications();
      } else {
        ElMessage({ message: result.msg, type: "error" });
      }
    }
    /**
     * 页面一开始加载就调用厂商列表
     */
    onMounted(async () => {
      await getApplications();
    });
    return {
      ...toRefs(state),
      page,
      applications,
      handleSearch,
      getApplications,
      manageApp,
      editApp,
      wantDelApp,
      delApp
    };
  },
});
